import { readCookie } from '../../utilities/SimpleStore'

const getLocaleFromCookie = () =>
  typeof window === 'undefined' ? '' : readCookie('dd_langauge') || ''

export default getLocaleFromCookie
